import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, withKeys as _withKeys, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "flex justify-content-between align-items-center w-full mb-5" }
const _hoisted_2 = { class: "font-semibold text-xl" }
const _hoisted_3 = {
  key: 0,
  class: "flex flex-column"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "icon-warpit_icon_settings" }, null, -1)
const _hoisted_5 = {
  key: 1,
  class: "flex flex-column pt-2 h-full"
}
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "block mb-2 font-semibold pb-3" }
const _hoisted_9 = { class: "flex flex-column gap-1" }
const _hoisted_10 = { class: "text-primary" }
const _hoisted_11 = { class: "flex gap-4 sm:gap-8" }
const _hoisted_12 = { class: "flex gap-1 flex-column sm:flex-row w-6rem sm:w-8rem mr-2" }
const _hoisted_13 = { class: "text-500" }
const _hoisted_14 = { class: "flex gap-2 md:gap-4 md:row-gap-2 flex-wrap" }
const _hoisted_15 = { class: "ml-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Divider = _resolveComponent("Divider")!

  return (_openBlock(), _createElementBlock("div", {
    tabindex: "1",
    class: "flex flex-column bg-white border-round-3xl border-1 border-300 p-4 w-20rem sm:w-25rem h-28rem cursor-pointer",
    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$router.push({ name: 'PrivateWasteTimeline' }))),
    onKeyup: _cache[3] || (_cache[3] = _withKeys(($event: any) => (_ctx.$router.push({ name: 'PrivateWasteTimeline' })), ["enter"]))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.$t("widgets.waste-collection.title")), 1),
      (_ctx.user)
        ? (_openBlock(), _createElementBlock("i", {
            key: 0,
            class: "icon-warpit_icon_settings text-2xl",
            tabindex: "1",
            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$emit('edit')), ["stop"])),
            onKeyup: _cache[1] || (_cache[1] = _withKeys(_withModifiers(($event: any) => (_ctx.$emit('edit')), ["stop"]), ["enter"]))
          }, null, 32))
        : _createCommentVNode("", true)
    ]),
    (!_ctx.externalId)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("span", null, _toDisplayString(_ctx.$t("widgets.not_configured")), 1),
          _createElementVNode("span", null, [
            _createTextVNode(_toDisplayString(_ctx.$t("widgets.configure")) + " ", 1),
            _hoisted_4,
            _createTextVNode(".")
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_5, [
          (_ctx.firstTwoDates && Object.keys(_ctx.firstTwoDates).length === 0)
            ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.$t("widgets.waste-collection.empty")), 1))
            : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$t("widgets.waste-collection.collections")), 1),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.firstTwoDates, (collections, date) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: date,
                    class: "flex flex-column"
                  }, [
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.buildAddress(collections[0].address)), 1),
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("div", _hoisted_12, [
                          _createElementVNode("span", null, _toDisplayString(_ctx.$moment(date, "DD.MM.YYYY").format("dddd")), 1),
                          _createElementVNode("span", _hoisted_13, _toDisplayString(date), 1)
                        ]),
                        _createElementVNode("div", _hoisted_14, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(collections, (collection) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: collection.id
                            }, [
                              _createElementVNode("span", {
                                class: _normalizeClass(["icon text-900", [
                      _ctx.getTrashcanValue(collection.waste_type, 'icon'),
                      _ctx.getTrashcanValue(collection.waste_type, 'name'),
                    ]])
                              }, null, 2),
                              _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.getTrashcanValue(collection.waste_type, "title")), 1)
                            ]))
                          }), 128))
                        ])
                      ]),
                      _createVNode(_component_Divider)
                    ])
                  ]))
                }), 128))
              ]))
        ]))
  ], 32))
}